import { Box, useTheme } from '@mui/material';
import { tokens } from '../../global/theme/tokens';
import Typography from '@mui/material/Typography';
import ExoAvatar from '../exo/ExoAvatar';
import { createElement, useEffect, useState } from 'react';
import RenderHTML from '../preview/RenderHTML';

const PersonRadio = ({
  person,
  onClick = () => {},
  checked = false,
  address,
  component,
  project,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  const picture = person.picture ? person.picture.thumbnailUrl : '';
  const name = person.lastName + ' ' + person.firstName;
  const position = person.position;

  const [selected, setSelected] = useState(checked);

  useEffect(() => {
    setSelected(checked);
  }, [checked]);

  function handleClick() {
    onClick(person);
  }

  return (
    <Box
      onClick={handleClick}
      className="flex justify-between px-1 py-1 rounded-lg peer-checked:border-2 cursor-pointer items-center"
      sx={{
        backgroundColor: selected ? colors.selected : colors.bgInput,
      }}
    >
      <Box className="flex flex-row items-center gap-4">
        <ExoAvatar
          icon={person.icon}
          picture={picture}
          size="64px"
          name={name}
          color={person.color}
        />
        <Box>
          <Typography variant="h5">{name}</Typography>
          {position && (
            <Typography
              variant="h5"
              sx={{
                color: colors.blueAccent[500],
              }}
            >
              {position}
            </Typography>
          )}
          {address && (
            <Typography className="opacity-50">
              {`${address.street || ''} ${address.houseNumber || ''} - ${address.zipCode || ''} ${address.city || ''}`}
            </Typography>
          )}
          {person.note && (
            <Typography className=" opacity-50">
              <RenderHTML HTML={person.note} />
            </Typography>
          )}
        </Box>
      </Box>
      {component ? (
        createElement(component, {
          selected: selected,
          person: person,
          project: project,
        })
      ) : (
        <></>
      )}
    </Box>
  );
};

// FUNCTIONS
/*function getInitials(name) {
  let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');

  let initials = [...name.matchAll(rgx)] || [];

  initials = (
    (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
  ).toUpperCase();

  return initials;
}*/

export default PersonRadio;
